import { produce } from "immer";

import { formatPermission } from "./../utils";

const PermissionReducer = produce((draft = {}, action = {}) => {
  switch (action.type) {
    case "FETCH_PERMISSION":
      draft.loading = true;
      return draft;
    case "FETCH_PERMISSION_SUCCESS":
      draft.loading = false;
      draft.permission = formatPermission(action.payload?.module_roles?.list);
      return draft;
    case "FETCH_PERMISSION_FAIL":
      draft.loading = false;
      return draft;
    default:
      return draft;
  }
});

export default PermissionReducer;
